const invertedMessages = {
  'External user classification started succesfully.':
    'external.dashboard.job.success',
};

export default invertedMessages;
